export const GET_REPORT_REQUEST = 'GET_REPORT_REQUEST';
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
export const GET_REPORT_FAILED = 'GET_REPORT_FAILED';

export const UPDATE_REPORT_REQUEST = 'UPDATE_REPORT_REQUEST';
export const UPDATE_REPORT_SUCCESS = 'UPDATE_REPORT_SUCCESS';
export const UPDATE_REPORT_FAILED = 'UPDATE_REPORT_FAILED';

export const CANCEL_REPORT_REQUEST = 'CANCEL_REPORT_REQUEST';
export const CANCEL_REPORT_SUCCESS = 'CANCEL_REPORT_SUCCESS';
export const CANCEL_REPORT_FAILED = 'CANCEL_REPORT_FAILED';
